<div class="content">
    <h3 class="summary-pointers">{{ summaryPageData.confirmdescription }}</h3>
    <div class="flex-container">
        <div class="feature-content">
            <div class="feature-list" *ngFor="let feature of features">
                <xm-media-image [imageOptions]="circleCheckGreyIcon" size="height" class="icons"></xm-media-image>
                <div class="feature-details">
                    <cms-text class="feature-description" [originalText]="feature.subHeader"></cms-text>
                    <cms-text *ngIf="feature.modal" class="feature-description" [originalText]="feature.modal"
                        (onButtonClick)="launchPayAsYouGoModal()">
                    </cms-text>
                    <cms-text *ngIf="feature.link" class="feature-description" [originalText]="feature.link">
                    </cms-text>
                </div>
            </div>
        </div>
    </div>
</div>
